import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

import { AuthService } from './service';

export type AuthState = AuthService['state'];

export type AuthSelector<T> = (state: AuthState) => T;

export const getUserId = (state: AuthState) => state.context.userId;
export const getRgUser = (state: AuthState) => state.context.rgUser;
export const getRgInfo = createSelector(
  getRgUser,
  get('rgUser'),
);

export const getDisplayName = createSelector(
  getRgInfo,
  (rgInfo) => `${rgInfo?.first_name} ${rgInfo?.last_name}`,
);


export const getLogRocketInfo = createSelector(
  getUserId,
  getRgUser,
  (userId, rgUser) => ({ userId, rgUser }),
);
